var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NavigationLine__Container"},[_c('div',{class:['NavigationLine__Line', _vm.selected ? '' : 'NavigationLine__Line_Unselected']},[_c('div',{staticClass:"Arrow"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }